import { debounce } from 'lodash-es'
import { showContact as openContact } from '@youyan/common'

export const showContact = debounce((name?: string) => {
  if (isChinese()) {
    openContact(
      name
        ? getFeUrl('/youyan-platform/png/qrcode/drainage/' + name + '.png')
        : name
    )
  } else {
    // 海外留资
    window.open('/contact-us')
  }
}, 200)
